import { render, staticRenderFns } from "./marketplace-menu-top.component.vue?vue&type=template&id=1ddf217a&scoped=true"
import script from "./marketplace-menu-top.component.vue?vue&type=script&lang=js"
export * from "./marketplace-menu-top.component.vue?vue&type=script&lang=js"
import style0 from "./marketplace-menu-top.component.vue?vue&type=style&index=0&id=1ddf217a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf217a",
  null
  
)

export default component.exports